import * as React from 'react';
import styled from '@emotion/styled';
import Carrusel from './Carrusel';
import CardFone from "../assets/images/Cards/Card-Fone.jpeg";
import CardImagen from "../assets/images/Cards/Card-Imagen.jpg";
import CardPFI from "../assets/images/Cards/Card-PFI.jpg";
import CardRatificacion from "../assets/images/Cards/Card-Ratificacion.jpg";
import CardTabulador from "../assets/images/Cards/Card-Tabulador.png";
import LogoCECAP from "../assets/logos/logo_cecap_v.png"

const News = () => {

const Title = styled.p`
    font-family: "Oswald", serif;
    font-size: 35px;
    color: black;
    border-bottom: 3px solid #005522;
    display: inline-block;
`;

const NewsDiv = styled.div`
    background: #ededed;
    padding-bottom: 50px;
`;

const Descripcion = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    display: inline-block;
    padding: 20px;
`;

const cards = [
    { title: "CERTIFICADOS DIGITALES", content: "El 29 de mayo del 2025, empezaron a emitirse los certificados digitales del programa TUM-B", 
        image: CardFone },
    { title: "PROGRAMA DE FORMACIÓN DE INSTRUCTORES", content: "Se realizó el primer Programa de Formación de Instructores en Sonora.", 
        image: CardPFI  },
    { title: "PRIMER CENTRO RATIFICADO", content: "El primer Centro de Capacitación a nivel nacional es Gómez Palacios, Durango.", 
        image: LogoCECAP },
    { title: "TABULADOR DE PUNTOS 2025", content: "Nuevo tabulador de puntos 2025 emitido por el Área Nacional de Formación Académica", 
        image: CardTabulador },
    { title: "CAMBIO DE IMAGEN", content: "La FONE tiene un cambio de imagen, logos, personificadores, gafetes, entre otros.", 
        image: CardImagen },
  ];

  return (
    <NewsDiv>
    <Title initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.6, ease: "easeOut" }}
    viewport={{ once: true }}> 
    NOVEDADES</Title>
    <Descripcion>Entérate de lo más reciente en nuestras actividades, capacitaciones y logros. Aquí encontrarás noticias clave, nuevas iniciativas y actualizaciones que impulsan el desarrollo de la comunidad a nivel nacional. ¡Mantente al día con todo lo que estamos haciendo!</Descripcion>
    <Carrusel cards={cards} LinkTo={"Facebook"}></Carrusel>
    </NewsDiv>
  );
};

export default News;